<template>
  <div class="header_container">
    <div class="header_left">管理系統</div>
    <div class="header_right"></div>
    <div class="user" v-if="user">
      <el-dropdown @command="onCommand">
        <span class="el-dropdown-link">
          {{user.username}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item command='editpwd'>修改密碼</el-dropdown-item> -->
          <el-dropdown-item command='logout'>退出登入</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import {removeToken,removeLocalUser} from '@/config/cache'
export default {
  name: "ipo3header",
  data() {
    return {
      user:null,
    };
  },
  created(){
    this.user = this.$store.getters.userInfo;
  },
  methods:{
    onCommand(command)
    {
      console.log("target:",command);
      if(command === 'logout')
      {
          removeToken('');
          removeLocalUser('');
          this.$router.push('/login')
      }
    }
  }
};
</script>
<style lang='less'>
.header_container {
  height: 100%;
  width: 100%;
  // background:red;
  display: flex;
  .header_left {
    // background: red;
    width: 150px;
    line-height: 55px;
    flex: none;
    font-size: 20px;
  }
  .header_right {
    flex: 1;
  }
  .user {
    width: 120px;
    flex: none;
    color:white;
    line-height: 55px;
    cursor: pointer;
    .el-dropdown{
      color:white !important;
    }
  }
}
</style>